import React, { useContext } from 'react'
import WizardNavigationBarLayout from '@Components/WizardFlow/WizardNavigationBarLayout'
import WizardBackButton from '@Components/WizardFlow/WizardBackButton'
import WizardNextButton from '@Components/WizardFlow/WizardNextButton'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import WizardSubmitButton from '@Components/WizardFlow/WizardSubmitButton'

const TransferNavBar = () => {
    const { catalogTransferWizardStore, wizardFlowStore, preloaderStore, userStore } = useContext(StoresContext)

    const RightContent = observer(() =>
        wizardFlowStore.currentIndex === 0 ? (
            <></>
        ) : wizardFlowStore.onLastStep ? (
            wizardFlowStore.currentSubIndex === 0 && (
                <WizardSubmitButton
                    disabled={userStore.isInternal}
                    onSubmitButtonPressed={() => {
                        preloaderStore.openTransparentPreloader(true)
                        catalogTransferWizardStore
                            .submitCatalogTransfer()
                            .then(wizardFlowStore.advanceSubIndex)
                            .finally(() => preloaderStore.openTransparentPreloader(false))
                    }}
                />
            )
        ) : (
            <WizardNextButton disabled={!catalogTransferWizardStore.wizardStepIsValid} />
        )
    )

    return (
        <WizardNavigationBarLayout
            leftContent={<WizardBackButton />}
            middleContent={<></>}
            rightContent={<RightContent />}
        />
    )
}

export default observer(TransferNavBar)
